import { put, select, takeEvery } from 'redux-saga/effects';

import { Selectors as Router } from 'router';
import { Actions as CampaignActions } from 'sections/campaigns/state/campaigns';
import { Actions as RulesetActions } from 'sections/campaigns/state/rulesets';
import { Types } from './types';

function* discard() {
  const campaignId = yield select(Router.getCampaignId);
  yield put(CampaignActions.discardLocal(campaignId));

  yield put(RulesetActions.discardAllLocal());
}

export function* listenForDiscard() {
  yield takeEvery(Types.DISCARD_CHANGES, discard);
}
